export default __webpack_public_path__ + "src/images/packages/lachataigne-farm/a464ccae58ccddc974689b15be58015e-4.png";